import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import { capitalize } from 'lodash';
import actions from './actions';
import { tableConfig } from '../../../../settings';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import { t } from '../../../../i18n';
import notifications from '../../../../redux/notifications/actions';
import Api, { executeAction } from '../../../../helpers/api';

const api = new Api('jobs/:id/adjustments');

const formatItems = (item, _status, currentOrganizationId) => {
  if (item.worker?.organization_id && currentOrganizationId) {
    item.disabled = true;
  }
};

function* loadOutstandingData({ payload }) {
  const state = yield select();

  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id, status } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, tab: 'outstanding' }, id },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns } = result.data.success.data;
      const currentOrganizationId = state.StartAppSettings.organization.id;

      records.forEach(item => formatItems(item, status, currentOrganizationId));

      yield put(
        actions.loadOutstandingDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadResolvedData({ payload }) {
  const state = yield select();

  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id, status } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, tab: 'resolved' }, id },
      notifications.REQUEST_ERROR,
    );

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns } = result.data.success.data;
      const currentOrganizationId = state.StartAppSettings.organization.id;

      records.forEach(item => formatItems(item, status, currentOrganizationId));

      yield put(
        actions.loadResolvedDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* resolveAction({ payload }) {
  try {
    const { method, url, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: capitalize(t('dash.common.notification.resolved_successfully').trim()),
        }),
      );
    }

    if (cb) {
      cb();
    }
  } catch (error) {
    logger.error(error);
  }
}

function* reopenAction({ payload }) {
  try {
    const { method, url, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: capitalize(t('dash.common.notification.reopened_successfully').trim()),
        }),
      );
    }

    if (cb) {
      cb();
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }) {
  try {
    const { method, url, cb } = payload;

    yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (cb) {
      cb();
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_RESOLVED, loadResolvedData),
    takeEvery(actions.LOAD_OUTSTANDING, loadOutstandingData),
    takeEvery(actions.RESOLVE_ACTION, resolveAction),
    takeEvery(actions.REOPEN_ACTION, reopenAction),
    takeEvery(actions.PROCESS_ACTION, processAction),
  ]);
}
